module.exports = __webpack_public_path__ + "static/media/edit-merchant.6d315a75.svg";